export default "__VITE_ASSET__DNx_Jyor__"